module.exports = __webpack_public_path__ + "img/DiHS_Video_Icon_Sr_Multiview3.7a43c0e9.jpg";